import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getUnitOfMeasurements = createAsyncThunk(
  "UnitOfMeasurement/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(`${API_URL.UNIT_OF_MEASUREMENT.SLUG}?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Lookup variant — hits the permission-free /lookup endpoint. Used by dropdowns
// on screens of other modules; the management list keeps using getUnitOfMeasurements.
export const getUnitOfMeasurementsLookup = createAsyncThunk(
  "UnitOfMeasurement/getLookup",
  async (payload, { rejectWithValue }) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(`${API_URL.UNIT_OF_MEASUREMENT.LOOKUP}?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUnitOfMeasurement = createAsyncThunk(
  "UnitOfMeasurement/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${API_URL.UNIT_OF_MEASUREMENT.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteUnitOfMeasurement = createAsyncThunk(
  "UnitOfMeasurement/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${API_URL.UNIT_OF_MEASUREMENT.SLUG}/${id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const toggleUOMActive = createAsyncThunk(
  "UnitOfMeasurement/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.patch(`${API_URL.UNIT_OF_MEASUREMENT.SLUG}/${id}/toggle-active`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editUnitOfMeasurement = createAsyncThunk(
  "UnitOfMeasurement/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${API_URL.UNIT_OF_MEASUREMENT.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const unitOfMeasurementSlice = createSlice({
  name: "unitOfMeasurement",
  initialState: {
    unitOfMeasurement_list: [],
    current_values: null,
    active_payload: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUnitOfMeasurements.fulfilled, (state, action) => {
      state.unitOfMeasurement_list = action.payload.data.list;
    });
    builder.addCase(getUnitOfMeasurementsLookup.fulfilled, (state, action) => {
      state.unitOfMeasurement_list = action.payload.data.list;
    });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  unitOfMeasurementSlice.actions;
export default unitOfMeasurementSlice.reducer;
